import { render, staticRenderFns } from "./AdminJournalReceivedForm.vue?vue&type=template&id=72df50e8&scoped=true&"
import script from "./AdminJournalReceivedForm.vue?vue&type=script&lang=js&"
export * from "./AdminJournalReceivedForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72df50e8",
  null
  
)

export default component.exports